/**
 * File: useAppLayoutController.ts
 * Path: apps/admin/src/modules/layout/hooks/useAppLayoutController.ts
 * Description: AppLayout's page area: the current path and a ref to the scrolling main area, which is
 * sent back to the top on every page change, as a full page load would.
 */

import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

export const useAppLayoutController = () => {
  const { pathname } = useLocation();
  const mainRef = useRef<HTMLElement>(null);

  useEffect(() => {
    mainRef.current?.scrollTo({ top: 0 });
  }, [pathname]);

  return { pathname, mainRef };
};
